import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-tep-pai',
  standalone: false,
  templateUrl: './tep-pai.component.html',
  styleUrl: './tep-pai.component.scss'
})

export class TepPaiComponent  {

  annee: any;

  // Le JSON reçu est déjà imbriqué : tableau de blocs { programme, tep_prevu, tep_realise, actions[] }
  items: any[] = [];

  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;

  user: any;
  directionItems: any[] = [];
  isLoading: boolean = false;
  dateFin: any;
  dateDebut: any;

  // ─── État collapse/expand ─────────────────────────────────────────────────
  private openProgrammes = new Set<number>();
  private openActions    = new Set<number>();

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    // Initialize dates based on the exercise year
    if (this.annee) {
      this.dateDebut = `${this.annee}-01-01`;
      this.dateFin = `${this.annee}-12-31`;
    }
  }

  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
  }

  // ─── Chargement ──────────────────────────────────────────────────────────

  getStatistique() {
    this.ngxService.start();
    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      user_reference: this.user.reference,
      type_operation: 'data'
    };

    this.paramservice.getStatistiqueTepProgramePai(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.items = response.data.datas;           // tableau de blocs imbriqués
        this.totalRecords = this.items.length;
        this.expandAll();                     // tout ouvert par défaut
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
      }
    );
  }

  // ─── Collapse / Expand ───────────────────────────────────────────────────

  toggleProgramme(id: number) {
    this.openProgrammes.has(id)
      ? this.openProgrammes.delete(id)
      : this.openProgrammes.add(id);
  }

  toggleAction(id: number) {
    this.openActions.has(id)
      ? this.openActions.delete(id)
      : this.openActions.add(id);
  }

  isProgrammeOpen(id: number): boolean {
    return this.openProgrammes.has(id);
  }

  isActionOpen(id: number): boolean {
    return this.openActions.has(id);
  }

  expandAll() {
    this.items.forEach(bloc => {
      this.openProgrammes.add(bloc.programme.id);
      bloc.actions?.forEach((a: any) => this.openActions.add(a.action.id));
    });
  }

  collapseAll() {
    this.openProgrammes.clear();
    this.openActions.clear();
  }

  // ─── Calcul du taux d'exécution ──────────────────────────────────────────

  /**
   * Retourne le taux d'exécution en %.
   * Si tep_prevu = 0, on retourne 0 pour éviter la division par zéro.
   */
// Dans votre fichier TypeScript, mettez à jour la méthode getTaux
getTaux(tepPrevu: number, tepRealise: number): number {
    if (!tepPrevu || tepPrevu === 0) {
        return 0;
    }
    const taux = (tepRealise / tepPrevu) * 100;
    // Arrondir à 2 chiffres après la virgule
    return Math.round(taux * 100) / 100;
}

// Si vous voulez aussi un template pour le badge du taux
// Ajoutez cette méthode pour formater l'affichage


  // ─── Pagination (sur les blocs programmes) ───────────────────────────────

  onPageChangeProjets(event: any) {
    this.firstProjets = event.page * this.rowsProjets;
  }

  // ─── Export ──────────────────────────────────────────────────────────────

  exportPaiDetail() {
    if (!this.dateDebut || this.dateDebut === '') {
      this.dateDebut = this.annee ? `${this.annee}-01-01` : '';
    }
    if (!this.dateFin || this.dateFin === '') {
      this.dateFin = this.annee ? `${this.annee}-12-31` : '';
    }

    if (this.dateDebut === '' || this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'PAI détail', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === '' || this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'PAI détail', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    const requestData = {
      user_reference: this.user.reference,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: 'pdf'
    };

    this.ngxService.start();

    this.paramservice.getStatistiqueTepProgramePaiDetail(requestData).subscribe(
      (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        window.open(URL.createObjectURL(blob), '_blank');
        this.ngxService.stop();
        this.messageService.add({
          severity: 'success',
          summary: 'Téléchargement réussi',
          detail: 'PAI détail PDF téléchargé',
          life: 3000
        });
      },
      (error: any) => {
        this.ngxService.stop();
        if (error.error instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });
            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };
          reader.readAsText(error.error);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }

  exportToDocument(typeDoc: string) {
    // Ensure dates are set with defaults if not provided
    if (!this.dateDebut || this.dateDebut === '') {
      this.dateDebut = this.annee ? `${this.annee}-01-01` : '';
    }
    if (!this.dateFin || this.dateFin === '') {
      this.dateFin = this.annee ? `${this.annee}-12-31` : '';
    }

    if (this.dateDebut === '' || this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === '' || this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    const requestData = {
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      user_reference: this.user.reference,
      type_operation: typeDoc
    };
    this.ngxService.start();

    this.paramservice.getStatistiqueTepProgramePaiDoc(requestData).subscribe(
      (response: Blob) => {
        if (typeDoc === 'pdf') {
          const blob = new Blob([response], { type: 'application/pdf' });
          window.open(URL.createObjectURL(blob), '_blank');
        } else {
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          FileSaver.saveAs(blob, 'Statistiques_pai.xlsx');
        }
        this.ngxService.stop();
        this.messageService.add({
          severity: 'success',
          summary: 'Téléchargement réussi',
          detail: `Fichier ${typeDoc.toUpperCase()} téléchargé`,
          life: 3000
        });
      },
          (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }

  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => { this.directionItems = response.data; },
      (error) => { console.error('Erreur direction', error); }
    );
  }
}